import { Box, Typography, Divider } from '@mui/material';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
    return (
        <Box sx={{
            background: '#111111',
            color: 'white',
            px: { xs: 3, md: 8 },
            pt: 5,
            pb: 3,
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'center', sm: 'flex-start' },
                gap: 4,
                mb: 4,
            }}>
                {/* Brand */}
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 1, mb: 0.5 }}>
                        ATS Verifier
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#aaa', maxWidth: 240 }}>
                        Match your resume to job descriptions using AI-powered analysis.
                    </Typography>
                </Box>

                {/* Links */}
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#ccc', textTransform: 'uppercase', letterSpacing: 1 }}>
                        Company
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#aaa', mb: 0.5 }}>Webtrabs</Typography>
                    <Typography variant="body2" sx={{ color: '#aaa' }}>
                        <a href="mailto:contact@webtrabs.com" style={{ color: '#aaa', textDecoration: 'none' }}>
                            contact@webtrabs.com
                        </a>
                    </Typography>
                </Box>

                {/* Social */}
                <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#ccc', textTransform: 'uppercase', letterSpacing: 1 }}>
                        Follow Us
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1.5, justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                        {/* <a href="https://www.linkedin.com/in/pocha-jaganmohan/" target="_blank" rel="noreferrer"
                            style={{ color: '#aaa', display: 'flex', alignItems: 'center' }}>
                            <LinkedInIcon sx={{ fontSize: 22, '&:hover': { color: '#0A66C2' }, transition: 'color 0.2s' }} />
                        </a> */}
                        <a href="https://www.instagram.com/webtrabs.official/" target="_blank" rel="noreferrer"
                            style={{ color: '#aaa', display: 'flex', alignItems: 'center' }}>
                            <InstagramIcon sx={{ fontSize: 22, '&:hover': { color: '#E1306C' }, transition: 'color 0.2s' }} />
                        </a>
                        <a href="mailto:contact@webtrabs.com"
                            style={{ color: '#aaa', display: 'flex', alignItems: 'center' }}>
                            <EmailIcon sx={{ fontSize: 22, '&:hover': { color: 'white' }, transition: 'color 0.2s' }} />
                        </a>
                    </Box>
                </Box>
            </Box>

            <Divider sx={{ borderColor: '#333', mb: 2.5 }} />

            <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                © {new Date().getFullYear()} Webtrabs. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;
